var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-title"},[_c('span',[_vm._v("————")]),_c('b',[_vm._t("title")],2),_c('span',[_vm._v("————")]),_c('p',[_vm._t("subtitle")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }